const getApiBaseUrl = (): string => {
  return import.meta.env.VITE_API_BASE_URL
}

export const config = {
  api: {
    baseUrl: getApiBaseUrl(),
    timeout: Number(import.meta.env.VITE_API_TIMEOUT) || 30000,
  },
  storage: {
    baseUrl: import.meta.env.VITE_STORAGE_URL,
  },
  app: {
    name: import.meta.env.VITE_APP_NAME,
    url: import.meta.env.VITE_APP_URL,
  },
} as const
